import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { Empty } from 'antd';
import {
    HeartTwoTone, TagsOutlined, LinkOutlined, AmazonOutlined,
    PlayCircleOutlined, ClockCircleOutlined, FileDoneOutlined, ApiOutlined
} from '@ant-design/icons';

import InfoCard from '../InfoCard/InfoCard';
import SiteScreenshot from '../SiteScreenshot/SiteScreenshot';

class SiteAnalytics extends Component {
    timeConversion = millisec => {
        var seconds = (millisec / 1000).toFixed(1);

        var minutes = (millisec / (1000 * 60)).toFixed(1);

        var hours = (millisec / (1000 * 60 * 60)).toFixed(1);

        var days = (millisec / (1000 * 60 * 60 * 24)).toFixed(1);

        if (seconds < 60) {
            return seconds + " sec";
        } else if (minutes < 60) {
            return minutes + " min";
        } else if (hours < 24) {
            return hours + " hrs";
        } else {
            return days + " days"
        }
    }

    getSiteAnalytics = (analytics, siteId) => {
        if (!analytics || Object.keys(analytics).length === 0 || !siteId) return [];
        const flatAnalytics = _.flatten(Object.keys(analytics).map(k => Object.keys(analytics[k]).map(l => analytics[k][l])));
        const relevantAnalytics = flatAnalytics.filter(a => a.siteId === siteId);
        return relevantAnalytics;
    }

    getHeartColor = (healthScrore) => {
        if (healthScrore > 90) return "#0ec851";
        if (healthScrore > 60) return "#fdd340";
        if (healthScrore > 40) return "#ec605e";
        return 'lightgrey';
    }

    render() {
        const { analytics, site = {}, job = {}, loading, isLatest } = this.props;
        const {
            healthScore = 0,
            links: analyticsLinks = {},
            products: analyticsProducts = {},
            crawlPageCount,
            credits = {},
        } = analytics || {};
       

        const { siteUrl, screenshotUrl, propertyType } = site;
        const { dateStarted, dateScheduled, dateStopped } = job;
        const jobLength = dateStopped - (dateStarted || dateScheduled);

        if (!analytics || !Object.keys(analytics).length) return (
            <div style={{
                margin: '10px',
                borderRadius: '5px',
                height: '200px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid gainsboro',
                width: '100%',
            }}>
                <Empty
                    image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
                    imageStyle={{ height: 60 }}
                    description="Complete a Crawl to Unlock Overview"
                />
            </div>
        )

        return (
            <div style={{ margin: '20px 0' }}>
                <div style={{ display: 'flex', }} className="reportheader-cards">
                    <div style={{ marginRight: 10 }}>
                        <SiteScreenshot href={siteUrl} url={screenshotUrl} isYT={propertyType === 'youtube'} showUrl={false} />
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 250px)', gridTemplateRows: 'repeat(2, 85px)', gridColumnGap: 5, gridRowGap: 2  }}>
                        <InfoCard
                            loading={loading}
                            metric={healthScore}
                            title="Health Score"
                            suffix="/ 100"
                            icon={props => <HeartTwoTone {...props} twoToneColor={this.getHeartColor(healthScore)} />}
                        />
                        <InfoCard
                            loading={loading}
                            metric={analyticsLinks.noAffiliateIdLiksCount}
                            title="Missing Affiliate Tags"
                            icon={props => <TagsOutlined {...props} />}
                            suffix={`/ ${analyticsLinks.totalLinksCount}`}
                        />
                        <InfoCard
                            loading={loading}
                            metric={analyticsLinks.totalUnealthyLinksCount}
                            title="Broken Links"
                            suffix={`/ ${analyticsLinks.totalLinksCount}`}
                            icon={props => <LinkOutlined {...props} />}
                        />
                        <InfoCard
                            loading={loading}
                            metric={analyticsProducts.totalUnhealthyProductsCount}
                            title="Broken Products"
                            icon={props => <AmazonOutlined {...props} />}
                            suffix={`/ ${analyticsProducts.totalProductCount}`}
                        />
                        <InfoCard
                            loading={loading}
                            metric={moment(dateStarted).format('DD MMM, HH:MM:SS')}
                            title={"Crawl Started"}
                            icon={props => <PlayCircleOutlined {...props} />}
                            isDate={true}
                        />
                        <InfoCard
                            loading={loading}
                            metric={this.timeConversion(jobLength)}
                            title={"Crawl Duration"}
                            icon={props => <ClockCircleOutlined {...props} />}
                        />
                        <InfoCard
                            loading={loading}
                            metric={crawlPageCount}
                            title={"Pages Discovered"}
                            icon={props => <FileDoneOutlined {...props} />}
                        />
                        <InfoCard
                            loading={loading}
                            metric={credits.usedUserCredits}
                            title={ "Credits Used"}
                            icon={props => <ApiOutlined {...props} />}
                        />
                    </div>
                </div>
                {isLatest && <div style={{ textAlign: 'right', color: 'grey', fontSize: 12 }}>
                    Latest report data
                </div>}
            </div>
        );
    }
}

export default SiteAnalytics;